import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Set page title
document.title = 'La Medicina Natural';
// Set favicon using SVG (herb/leaf icon)
const faviconSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <rect width="32" height="32" rx="8" fill="#2D5A3D"/>
  <path d="M16 6C16 6 8 10 8 18C8 22.4 11.6 26 16 26C20.4 26 24 22.4 24 18C24 10 16 6 16 6Z" fill="#A7F3D0"/>
  <path d="M16 6C16 6 16 14 16 22" stroke="#2D5A3D" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M16 14C16 14 12 12 10 14" stroke="#2D5A3D" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M16 18C16 18 20 16 22 18" stroke="#2D5A3D" stroke-width="1.5" stroke-linecap="round"/>
</svg>`;
const blob = new Blob([faviconSvg], {
  type: 'image/svg+xml'
});
const url = URL.createObjectURL(blob);
const link = document.createElement('link');
link.rel = 'icon';
link.type = 'image/svg+xml';
link.href = url;
document.head.appendChild(link);
render(<App data-id="element-741" />, document.getElementById('root'));